export const environment = {
  "production": true,
  "baseUrl": "https://cfss.allcaresoftware.com/",
  "onboardingUrl": "https://cfss.allcaresoftware.com/",
  "uiVresion": "2.1.14",
  "hosturl": "https://cfss.allcaresoftware.com/",
  "utilizationReportId": "c2bbd2d2-019a-4ba1-b410-aac445038640",
  "revenueReportId": "b948f4bc-c355-43a0-9da2-6c6c21cd129a",
  "ClaimVsPaidReportId": "40e978ba-ee26-415d-8c4a-797d7f7c4849",
  "utilizationSummaryReportId": "14834977-a5de-462e-a360-3bd69536a599",
  "reportId": "0e1375a9-858c-4247-a259-b8b96047bc23",
  "reportId835": "446aca18-5e28-4bf9-8d21-b45fe5d58504",
  "ViewBatchReportId": "e9d74ae8-b9de-4a41-a52e-9aa7bdc1a69a",
  "SpendDownReportId": "17ebebf7-4221-420e-b5be-65470cd99d37",
  "BatchViewReportId": "9d76e37e-ff04-4874-b39d-ba90cca5aaa3",
  "customerWidgeturl": "https://customer.ccxai.com/customer-widget.js",
  "agentWidgeturl":"https://agent.ccxai.com/widget-loader.js",
  "receiveAgentWidgetMessage":"https://agent.ccxai.com",
  "isWidget":true,
  "LastDateOfServiceReportId": "fb133f9c-0b86-4fce-85be-bedb730a6441",
  "EmployeeClientMapReportId": "95ec84bd-b328-4e73-b5d3-eeeb2af0664d",
  "EmployeeClientMapExcelReportId": "3bcef3df-fc47-4974-89d0-d46e3272a7ab",
  "ComingDueAuthorizationChartReportId": "c14fb62c-77f6-493b-b414-c7669a01079b",
  "ComingDueAuthorizationReportId": "c557b3a9-eca0-42e1-adf5-66ac6df521c0",
  "TimesheetReportId":"012ef913-1dc7-4747-b8d5-b88a328bf70b"

}   